/*
  Promise-ified loading of the recaptcha script
*/

import { getRecaptchaLocale } from 'src/dataLayer/localData/languageCodes';

const RECAPTCHA_CALLBACK = 'RECAPTCHA_CALLBACK';
const RECAPTCHA_MAX_LOAD_TIME = 5000;

let recaptchaScriptLoaded = false;

const getRecaptchaScriptURL = (locale) => {
  const recaptchaLocale = getRecaptchaLocale(locale);
  return `https://www.google.com/recaptcha/api.js?onload=${RECAPTCHA_CALLBACK}&render=explicit&hl=${recaptchaLocale}`;
};

const createRecaptchaScriptTag = (recaptchaScriptURL) => {
  const recaptchaScriptTag = document.createElement('script');
  recaptchaScriptTag.setAttribute('src', recaptchaScriptURL);
  recaptchaScriptTag.setAttribute('async', true);
  recaptchaScriptTag.setAttribute('defer', true);
  document.querySelector('head').appendChild(recaptchaScriptTag);
};

// Will return the widget ID if render is successful
const renderRecaptchaOnLoad = ({ targetId, captchaKey, onSuccess, onError, onExpired }) => {
  try {
    return window.grecaptcha.render(targetId, {
      sitekey: captchaKey,
      callback: onSuccess,
      'error-callback': onError,
      'expired-callback': onExpired
    });
  } catch (err) {
    onError(err);
  }
};

const addRecaptchaScript = (args) =>
  new Promise((resolve, reject) => {
    window[RECAPTCHA_CALLBACK] = () => {
      recaptchaScriptLoaded = true;
      return resolve(renderRecaptchaOnLoad(args));
    };
    window.setTimeout(() => {
      return reject('The Recaptcha script failed to load.');
    }, RECAPTCHA_MAX_LOAD_TIME);
    const recaptchaScriptURL = getRecaptchaScriptURL(args.locale);
    createRecaptchaScriptTag(recaptchaScriptURL);
  });

export const resetRecaptcha = () =>
  window.grecaptcha.reset();

export default async (args) => {
  return recaptchaScriptLoaded
    ? renderRecaptchaOnLoad(args)
    : await addRecaptchaScript(args).catch((err) => args.onError(err));
};
